import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=21dd646d"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21dd646d')) {
      api.createRecord('21dd646d', component.options)
    } else {
      api.reload('21dd646d', component.options)
    }
    module.hot.accept("./Alert.vue?vue&type=template&id=21dd646d", function () {
      api.rerender('21dd646d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainContent/Alert.vue"
export default component.exports